import React from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import BannerSection from './BannnerSection/BannerSectionContainer';
import IntroSection from './IntroSection/IntroSection';
import ProsSection from './ProsSection/ProsSection';
import RecruitmentSteps from './RecruitmentSteps/RecruitmentSteps';
import CommentsSection from './CommentsSection/CommentsSectionContainer';
import JobsSection from './JobsSection/JobsSectionContainer';
import UniversitySection from './UniversitySection/UniversitySectionContainer';
import { recaptchaKey } from '../../static';
import RecruitmentTeam from './RecruitmentTeam/RecruitmentTeam';
import VideoSection from './VideoSection/VideoSection';

export default function MainPage({ isMobile }) {
  const recaptchaRef = React.useRef();

  return (
    <>
      <BannerSection />
      <IntroSection isMobile={isMobile} />
      <ProsSection isMobile={isMobile} />
      <VideoSection />
      <JobsSection isMobile={isMobile} recaptchaRef={recaptchaRef} />
      <RecruitmentSteps />
      <RecruitmentTeam isMobile={isMobile} />
      <CommentsSection isMobile={isMobile} />
      <UniversitySection isMobile={isMobile} />
      {/* <AcademySection /> */}
      <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={recaptchaKey} />
    </>
  );
}

MainPage.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};
